import { TagInfoType } from '@/constants/cart';
import useCart from '@/store/shopping';
import { isEmptyObject } from '@/utils/isEmpty';
import dynamic from 'next/dynamic';
import React, { useCallback, useEffect, useState } from 'react';
import { ProcessBarRef } from './progress-bar';
import Loading from '@/components/common/Indicator/Loading';
import useGlobalNavHeader from '@/hooks/globalnavheader/provider';

type Props = {
  height?: number;
  style?: React.CSSProperties;
  showClose?: boolean;
  onlyGrocery?: boolean;
  isSeller?: boolean;
  isNewStyle?: boolean;
  processBarRef?: ProcessBarRef;
  onStateChange?: (state: { visible: boolean; height: number }) => void;
};

const ProgressBarDynamic = dynamic(() => import('./progress-bar'), { ssr: false, loading: Loading });

export default function ProgressBar(props: Props) {
  const { isSeller } = props;
  const [loaded, setLoaded] = useState<boolean>(false);
  const { tagInfo, sellerTagInfo, shippingThresholdInfo } = useCart();
  const isUpsellBarHidden = useCallback(() => {
    const val = window.sessionStorage.getItem('hideUpsellBar');
    return val === '1';
  }, []);

  const globalNavHeader = useGlobalNavHeader();
  const streamlinedHeader = globalNavHeader?.streamlinedHeader || false;

  useEffect(() => {
    if (!isEmptyObject(tagInfo) || !isEmptyObject(sellerTagInfo)) {
      setLoaded(true);
    }

    /**
     * hideUpsellBar 为true，说明用户之前加购满足68换购条件了，并且连续下拉两次
     * 这里在tagInfo变化时，判断如果用户减购，重新达到68门槛时，重新展示upsell bar
     */
    if (isUpsellBarHidden() && !isEmptyObject(tagInfo)) {
      if (tagInfo.progressBarType === TagInfoType.trade_in_upsell && tagInfo.diff_price > 0) {
        window.sessionStorage.setItem('hideUpsellBar', '0');
      }
    }
  }, [tagInfo, sellerTagInfo]);

  if (!loaded) return null;

  return (
    <ProgressBarDynamic
      {...props}
      streamlinedHeader={streamlinedHeader}
      tagType={shippingThresholdInfo?.addCartTagType}
      tagInfo={isSeller ? sellerTagInfo : tagInfo}
    />
  );
}
